{
  "order": {
    "unpaid": "Unpaid",
    "pending": "Pending",
    "packed": "Packed",
    "awaiting_shipment": "Awaiting shipment",
    "ready_to_ship": "Ready to ship",
    "shipped": "Shipped",
    "delivered": "Delivered",
    "cancelled": "Cancelled",
    "returned": "Returned",
    "lost_by_3pl": "Lost by 3PL",
    "damaged_by_3pl": "Damaged by 3PL",
    "confirmed": "Confirmed",
    "completed": "Completed"
  },
  "payment": {
    "pending": "Pending",
    "paid": "Paid",
    "failed": "Failed"
  },
  "promotion": {
    "draft": "Draft",
    "active": "Active",
    "finished": "Finished"
  },
  "stock": {
    "healthy": "Healthy",
    "low_stock": "Low stock",
    "out_of_stock": "Out of stock",
    "oversold": "Oversold"
  },
  "sync": {
    "in_progress": "Syncing",
    "ok": "Synced",
    "failed": "Sync failed"
  }
}
